import React from 'react';
import { UncontrolledPopover, PopoverHeader, PopoverBody } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { FMessage } from '../../../../hoc/IntlComponents';
import { getStoreUrl } from '../../../../utils/utils';
import { STATIC_PATH } from '../../../../config';

// const renderCoinTooltip = ({ id, target, coins }) => {
//   return (
//     <UncontrolledPopover
//       trigger="hover"
//       className="offer-coins-popover"
//       placement="left"
//       target={`${target}-${id}`}
//     >
//       <PopoverHeader>
//         {' '}
//         <b>
//           <FMessage id="offer.tooltip.header" />
//         </b>
//       </PopoverHeader>
//       <PopoverBody>
//         {' '}
//         <div>
//           <FormattedMessage
//             id="offer.tooltip.p"
//             defaultMessage="According to this offer,  {coins, plural, one {# coin} other {# coins} } is charged for a confirmed application. Coins you can spend on "
//             values={{
//               coins,
//             }}
//           />
//           <a href={getStoreUrl()} target="_blank">
//             <FMessage id="offer.tooltip.link-to-store" />
//           </a>
//         </div>
//       </PopoverBody>
//     </UncontrolledPopover>
//   );
// };

const renderCoins = (coins, id, index, pixel) => {
  if (coins === 1) {
    return (
      <div
        id={`coins-${coins}-${id}`}
        key={`coins_${pixel.id}_${id}_${index}`}
        className={`coins-${coins}`}
      >
        <img src={`${STATIC_PATH}/img/coin-big.svg`} />
        {/* {renderCoinTooltip({ id, target: `coins-${coins}`, coins })} */}
      </div>
    );
  } else if (coins === 2) {
    return (
      <div
        id={`coins-${coins}-${id}`}
        key={`coins_${pixel.id}_${id}_${index}`}
        className={`coins-${coins}`}
      >
        <img src={`${STATIC_PATH}/img/coin-big.svg`} />
        <img src={`${STATIC_PATH}/img/coin-big.svg`} />
        {/* {renderCoinTooltip({ id, target: `coins-${coins}`, coins })} */}
      </div>
    );
  }
  return null;
};

const OffersListItemCoins = ({ coins, id, pixels, isCollapsed, collapsedItems }) =>
  pixels.length > 0 &&
  coins > 0 && (
    <div className="offers-list-table-cell offers-list-table-cell--coins">
      {pixels.map((pixel, index) => {
        if (!isCollapsed || index < collapsedItems) {
          return renderCoins(coins, `coins_${pixel.id}_${id}`, index, pixel);
        }
        return null;
      })}
    </div>
  );

export default OffersListItemCoins;
